module.exports = {
  useFragmentInjector: require('./fragment-injector').default,
  Portal: require('./portal').default
};